import * as React from 'react'

import { LOCIZE_NAMESPACE } from 'main/common'
import { i18nKeyPrefix } from 'main/pages/Search/i18n'
import { formatTimeString } from 'main/ui/slider/util'
import { IFilters } from 'main/util/search'
import { TFunction, useTranslation } from 'react-i18next'

import { FilterControl } from '../common'
import IFullSearchProps from '../types'
import FilterForm from './FilterForm'

const PRE = `${i18nKeyPrefix}-FILTERS-DROP-OFF`

export default function DropOffHoursFilter(props: IFullSearchProps) {
  const {
    filters,
    displayForm,
    palette,
    onChangeFilters,
    onRequestCloseForm,
    onRequestDisplayForm,
  } = props

  const { t } = useTranslation(LOCIZE_NAMESPACE)

  const isActive = !!(filters.dropOffStartsAt || filters.dropOffEndsAt)

  return (
    <div data-pendo="dropOffFilterButton">
      <FilterControl
        isActive={isActive}
        label={isActive ? getActiveLabel(filters, t) : t(`${PRE}-LABEL`)}
        displayForm={displayForm}
        palette={palette}
        onRequestCloseForm={onRequestCloseForm}
        onRequestDisplayForm={onRequestDisplayForm}
        filterForm={
          <FilterForm
            filters={filters}
            onChangeFilters={onChangeFilters}
            onRequestCloseForm={onRequestCloseForm}
          />
        }
      />
    </div>
  )
}

function getActiveLabel(filters: IFilters, t: TFunction) {
  const dropOffStartsAt = filters.dropOffStartsAt && formatTimeString(filters.dropOffStartsAt)
  const dropOffEndsAt = filters.dropOffEndsAt && formatTimeString(filters.dropOffEndsAt)
  return t(`${PRE}-ACTIVE-LABEL`, { dropOffStartsAt, dropOffEndsAt })
}
